module.exports = __webpack_public_path__ + "static/media/address-thumbnail.96349c6a.jpeg";